import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaScript from '@/components/base/SchemaScript';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ValueProposition from './components/ValueProposition';
import FeatureGrid from './components/FeatureGrid';
import TrustSection from './components/TrustSection';
import ArticlePreview from './components/ArticlePreview';
import FinalCTA from './components/FinalCTA';

const siteUrl = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "ItaobuySpreadsheet",
  "url": `${siteUrl}/`,
  "description": "A structured product intelligence system for smart shopping comparison and supplier analysis.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategorySection />
          <ValueProposition />
          <FeatureGrid />
          <TrustSection />
          <ArticlePreview />
          <FinalCTA />
        </main>

        <Footer />
      </div>

      <SchemaScript data={websiteSchema} />
    </>
  );
}